import { Card, TextField, CardContent, Button, FormControl, Grid, InputBase, IconButton, Paper, MenuItem } from '@mui/material';

import { LinearLoading, CustomAutocomplete } from 'common'

import { InfoVehicleReception } from './InfoVehicleReception'

export const FormPremisesManagements = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { formOpeningMode, loadingSubmitForm } = globalStates

    // ------------------------------------------------ Helpers
    const { identifySelectedRequestType } = Helpers
    
    // ------------------------------------------------ Formularios
    const { FormScreen } = Forms
    const { formState, onInputChange, onInputNumberChange, onSelectSearchChange } = FormScreen
    
    // ------------------------------------------------ FetchData
    const { fetchSpecificManagement, fetchManagementTypes } = FetchData
    const { loadingFetchSpecificManagement } = fetchSpecificManagement
    const { dataManagementTypes, loadingFetchManagementTypes } = fetchManagementTypes

    // ------------------------------------------------ Actions
    const {
        onSubmitForm,
        handleClickHideForm,
        handleClickSearchVehicleReception
    } = Actions

    const readOnlyMode = (formOpeningMode==='READONLY')

    return (
        <Card style={{zIndex:'1'}}>
            <CardContent>
                <div className='h4 mt-1 mb-1'>
                    {formState.idmanagement > 0
                        ? 'Actualizar Registro'
                        : 'Crear Registro'}
                </div>
                <div className="border-bottom border-dark"></div>
                {loadingFetchSpecificManagement && ( <LinearLoading /> )}

                <div className="pt-3"></div>
                <p className='text-danger'>* campos obligatorios</p>
                <div className="pt-2"></div>

                <form onSubmit={onSubmitForm}>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl fullWidth>
                                <label htmlFor="recepcion_codigo"> * Identificador de recepción</label>
                                <Paper
                                    sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
                                >
                                    <InputBase
                                        id="recepcion_codigo"
                                        name="recepcion_codigo"
                                        value={formState.recepcion_codigo}
                                        onChange={onInputChange}
                                        sx={{ ml: 1, flex: 1 }}
                                        placeholder="Identificador de recepción"
                                        inputProps={{ 
                                            'aria-label': 'recepcion_codigo',
                                            readOnly: true 
                                        }}
                                        required
                                    />
                                    <IconButton
                                        type="button" sx={{ p: '10px' }}
                                        aria-label="search"
                                        onClick={handleClickSearchVehicleReception}
                                        disabled={true}
                                    >
                                        <i className="fas fa-search"></i>
                                    </IconButton>
                                </Paper>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                    <InfoVehicleReception useFetchInit={useFetchInit} />
                    <div className="pt-4"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl fullWidth>
                                <label htmlFor="idmanagementtypes"> * Tipo gestión</label>
                                {(loadingFetchManagementTypes)&&(<LinearLoading/>)}
                                <CustomAutocomplete 
                                    customId="idmanagementtypes"
                                    customName="idmanagementtypes"
                                    customValue={formState.idmanagementtypes}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idmanagementtypes', value: value.value }  })}
                                    customPlaceholder='Selecciona un contrato'
                                    customOptions={
                                        dataManagementTypes.map(({ idmanagementtypes, prefijo, descripcion }) => ({
                                            value: idmanagementtypes,
                                            name: `${prefijo} - ${descripcion}`
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={true}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-4"></div>
                    {identifySelectedRequestType(dataManagementTypes, formState.idmanagementtypes) === 'EXP' && (
                        <>
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                                    <FormControl fullWidth>
                                        <label htmlFor="info_descuento"> * Monto a exonerar</label>
                                        <TextField
                                            id='info_descuento'
                                            name='info_descuento'
                                            value={ formState.info_descuento } 
                                            onChange={ onInputNumberChange }
                                            size='small'
                                            placeholder='500.50, 100.00'
                                            type='number'
                                            min="0"
                                            step="0.01"
                                            variant="filled"
                                            hiddenLabel
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                                    <FormControl fullWidth>
                                        <label htmlFor="info_descuento_aprobado"> * Monto a aprobar</label>
                                        <TextField
                                            id='info_descuento_aprobado'
                                            name='info_descuento_aprobado'
                                            value={ formState.info_descuento_aprobado } 
                                            onChange={ onInputNumberChange }
                                            size='small'
                                            placeholder='500.50, 100.00'
                                            type='number'
                                            min="0"
                                            step="0.01"
                                            variant="outlined"
                                            hiddenLabel
                                            InputProps={{
                                                readOnly: false
                                            }}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <div className="pt-2"></div>
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                                    <FormControl fullWidth>
                                        <label htmlFor="gestion_descripcion">Descripcion</label>
                                        <TextField
                                            id='gestion_descripcion'
                                            name='gestion_descripcion'
                                            value={ formState.gestion_descripcion } 
                                            onChange={ onInputChange }
                                            size='small'
                                            placeholder='Descripcion'
                                            type='text'
                                            multiline
                                            rows={5}
                                            variant={'filled'}
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </>
                    )}
                    
                    <div className="pt-4"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="aprobacion_check">* Tipo</label>
                                <TextField
                                    id="aprobacion_check"
                                    name="aprobacion_check"
                                    value={formState.aprobacion_check}
                                    onChange={onInputChange}
                                    select
                                    size="small"
                                    variant="outlined"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: false
                                    }}
                                >
                                    <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                    <MenuItem value='Pendiente Aprobacion'>Pendiente Aprobacion</MenuItem>
                                    <MenuItem value='Aprobado'>Aprobado</MenuItem>
                                    <MenuItem value='Rechazado'>Rechazado</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="aprobacion_fecha">Fecha de aprobacion / registro</label>
                                <TextField
                                    id='aprobacion_fecha'
                                    name='aprobacion_fecha'
                                    value={ formState.aprobacion_fecha } 
                                    // onChange={ onInputChange }
                                    size='small'
                                    placeholder='Fecha de aprobacion'
                                    type='date'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{
                                        readOnly: true 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="aprobacion_observaciones">Observaciones de aprobación</label>
                                <TextField
                                    id='aprobacion_observaciones'
                                    name='aprobacion_observaciones'
                                    value={ formState.aprobacion_observaciones } 
                                    onChange={ onInputChange }
                                    size='small'
                                    placeholder='Observaciones de aprobación'
                                    type='text'
                                    multiline
                                    rows={5}
                                    variant={readOnlyMode? 'filled': 'outlined'}
                                    InputProps={{
                                        readOnly: false
                                    }}
                                    
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                    <Grid container>
                        <Grid item>
                            <div className='update ml-auto mr-auto'>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type='submit'
                                    disabled={loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                    variant="contained"
                                    type='button'
                                    onClick={handleClickHideForm}
                                >
                                    <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}
